/* eslint-disable max-len */
var ICON_COMMS_LIKE = {
  "default": 'M12 8.53499C12 8.53499 14.2125 2.746 18.255 2.746C20.46 2.746 23.25 4.36483 23.25 8.45293C23.25 13.1155 15.1425 20.6352 12 22.254C8.8575 20.6352 0.75 13.1155 0.75 8.45293C0.75 4.36483 3.54 2.746 5.745 2.746C9.7875 2.746 12 8.53499 12 8.53499Z',
  v2: true
};

export { ICON_COMMS_LIKE };
//# sourceMappingURL=ICON_COMMS_LIKE.js.map
